import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const projectUTMTaggerRoutes = [
  {
    path: '/accounts/:accountId(\\d+)/projects/:projectId(\\d+)/utmtagger/groups',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('UTM-tagger')
      },
      permissions: ['READ_PLACEMENT_TAGGING_GROUPS']
    },
    children: [
      {
        path: '',
        name: 'placementTaggingGroupsList',
        component: wrapLegacyRoute('placementTaggingGroupsController', 'list')
      },
      {
        path: 'create/:channelId(\\d+)',
        name: 'placementTaggingGroupCreate',
        component: wrapLegacyRoute('placementTaggingGroupsController', 'create')
      },
      {
        path: 'groups/:groupId(\\d+)',
        name: 'placementTaggingGroupDetails',
        component: wrapLegacyRoute('placementTaggingGroupsController', 'details')
      }
    ]
  }
];

export default projectUTMTaggerRoutes;
